export enum TableType {
	WORK_ORDER = 'work_order',
	INCIDENTS = 'incident',
	REQUESTS = 'request',
	FILES = 'files',
	ASSETS = 'assets',
}
